import { call, put, select } from 'redux-saga/effects';
import cirrusClient from '../../../services/api/cirrus-client';
import { showSnackbar } from '../../../state/snackbar/snackbarSlice';
import { selectUserCredentials } from '../../../state/userCredential/userCredentialSlice';
import { fetchContactAction } from '../fetchContact/action';

export function* addContactSaga(action) {
    const { contactId } = action.payload;
    try {
        const { domain, user } = yield select(selectUserCredentials);
        const contactData = action.payload; 
        const params = {
            'name-first-name': contactData.first_name,
            'name-middle-name': '',  
            'name-last-name': contactData.last_name,
            'email': contactData.email,
            'company': contactData.group || '', 
            'phonenumber-work': contactData.work_phone || '', 
            'phonenumber-cell': contactData.cell_phone || '', 
            'phonenumber-fax': contactData.fax || '',
            'phonenumber-home': contactData.home_phone || '',  
        };
        const response = yield call(cirrusClient.post, `/v2/domains/${domain}/users/${user}/contacts`, params);
        if (response.data && response.data['unique-id']) {
            yield put(fetchContactAction());
            yield put(showSnackbar({
                message: 'Contact created successfully',
                severity: 'success'
            }));
        }
    } catch (error) {
        console.error('Error creating contact:', error);
        yield put(showSnackbar({
            message: 'Failed to create a contact',
            severity: 'error'
        }));
    }
}